/**
 * Dynamic date helpers for SEO and content freshness
 */

/**
 * Returns the current year
 */
export const getCurrentYear = (): number => {
  return new Date().getFullYear();
};

/**
 * Returns current month and year in Spanish
 * Example: "Diciembre 2024"
 */
export const getCurrentMonthYear = (): string => {
  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  const now = new Date();
  return `${months[now.getMonth()]} ${now.getFullYear()}`;
};

/**
 * Formats a review/update date in Spanish
 * Example: "15 de diciembre de 2024"
 */
export const formatReviewDate = (date: Date | string): string => {
  const months = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];
  const d = typeof date === 'string' ? new Date(date) : date;
  return `${d.getDate()} de ${months[d.getMonth()]} de ${d.getFullYear()}`;
};

/**
 * Replaces {year} placeholder in titles with current year
 * Example: "Mejores Vitaminas B12 en {year}" → "Mejores Vitaminas B12 en 2024"
 */
export const replaceTitleYear = (title: string): string => {
  return title.replace(/\{year\}/gi, getCurrentYear().toString());
};

/**
 * Replaces {month_year} placeholder in titles with current month and year
 * Example: "Guía Actualizada {month_year}" → "Guía Actualizada Diciembre 2024"
 */
export const replaceTitleMonthYear = (title: string): string => {
  return title.replace(/\{month_year\}/gi, getCurrentMonthYear());
};

/**
 * Processes a title replacing all dynamic date placeholders
 */
export const processDynamicTitle = (title: string): string => {
  let processed = replaceTitleYear(title);
  processed = replaceTitleMonthYear(processed);
  return processed;
};
